import moment from 'moment'
import {
  SET_MASTER_COURSE_FILTER,
  SET_UNREAD_NOTIFICATIONS_COUNT
} from '../actions/mycourses'
import { SET_CURRENT_ORGANIZATION } from '../actions/organization'

const initialState = {
  masterCourseFilterId: -1,
  activeTab: 'courses',
  unreadNotificationsCount: 0
}

export function mycourses(state = initialState, action) {
  switch (action.type) {
    case SET_UNREAD_NOTIFICATIONS_COUNT: {
      return {
        ...state,
        unreadNotificationsCount: action.payload.count
      }
    }

    case SET_MASTER_COURSE_FILTER:
      return {
        ...state,
        masterCourseFilterId: action.payload.masterCourseId
      }

    case SET_CURRENT_ORGANIZATION:
      return {
        ...state,
        masterCourseFilterId: -1
      }

    default:
      return state
  }
}
